import gql from 'graphql-tag';
import { searchEntityGQLFields, } from './searchEntity.fields.js';
export function searchGQLQuery(fields) {
    return gql `
    query search($input: SearchInput!) {
      search(input: $input) {
        totalCount
        hits {
          entityType
          hits {
            ${searchEntityGQLFields(fields)}
          }
        }
      }
    }
  `;
}
//# sourceMappingURL=search.gql.js.map